module.exports = __webpack_public_path__ + "img/freelance2.5dc22103.png";